import React from 'react';
import { Box, Button } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { exportTableCsv, exportTablePdf } from '../utils/tableExport';

const ExportButtons = ({
  title,
  filename,
  columns,
  rows,
  summary,
  extraSections,
  subtitle,
  landscape,
  disabled,
  csv = true,
  pdf = true,
  onError
}) => {
  const noData = disabled !== undefined ? disabled : !(rows && rows.length);

  const handleCsv = () => {
    try {
      exportTableCsv({ filename, title, columns, rows, summary, extraSections });
    } catch (err) {
      onError?.(err.message || 'CSV export failed');
    }
  };

  const handlePdf = () => {
    try {
      exportTablePdf({
        title,
        filename,
        columns,
        rows,
        summary,
        extraSections,
        subtitle,
        landscape
      });
    } catch (err) {
      onError?.(err.message || 'PDF export failed');
    }
  };

  return (
    <Box sx={{ display: 'inline-flex', gap: 1, flexWrap: 'wrap' }}>
      {csv && (
        <Button
          variant="outlined"
          size="small"
          startIcon={<FileDownloadIcon />}
          onClick={handleCsv}
          disabled={noData}
        >
          Export CSV
        </Button>
      )}
      {pdf && (
        <Button
          variant="outlined"
          size="small"
          color="secondary"
          startIcon={<PictureAsPdfIcon />}
          onClick={handlePdf}
          disabled={noData}
        >
          Export PDF
        </Button>
      )}
    </Box>
  );
};

export default ExportButtons;
